export var GlobalProperty;
(function (GlobalProperty) {
    GlobalProperty[GlobalProperty["Arguments"] = 0] = "Arguments";
    GlobalProperty[GlobalProperty["Modules"] = 1] = "Modules";
    GlobalProperty[GlobalProperty["CallingScriptHash"] = 2] = "CallingScriptHash";
    GlobalProperty[GlobalProperty["GenericLogSerialize"] = 3] = "GenericLogSerialize";
    GlobalProperty[GlobalProperty["CommonStorage"] = 4] = "CommonStorage";
    GlobalProperty[GlobalProperty["CommonStorageSerialized"] = 5] = "CommonStorageSerialized";
    GlobalProperty[GlobalProperty["Cache"] = 6] = "Cache";
    GlobalProperty[GlobalProperty["CacheStorage"] = 7] = "CacheStorage";
    GlobalProperty[GlobalProperty["DeleteCacheStorage"] = 8] = "DeleteCacheStorage";
})(GlobalProperty || (GlobalProperty = {}));

//# sourceMappingURL=GlobalProperty.js.map
